export const SM_BACKGROUND = 'rgb(80, 0, 0)';
export const HELPED_KEY = 'SM HELPED';
export const SM_PINK = 'rgba(233,127,161, 1)';
export const SM_GREEN = 'rgba(161,233,127, 1)';
export const SM_BLUE = 'rgba(127,161,233, 1)';
export const SM_PURPLE = 'rgba(199,127,233, 1)';
export const SM_GOLD = 'rgba(233, 199, 127, 1)';
export const SWAP_DURATION = 600;
export const FLIP_DURATION = 500;
export const YOUTUBE_SM = 'https://youtu.be/7uuorefZ-9Y';
